'use client';

import type { ReactNode } from 'react';
import type { UseFormRegister } from 'react-hook-form';

type Props = {
  name: string;
  register: UseFormRegister<any>;
  error?: string;
  children: ReactNode;
  required?: boolean;
};

export function CheckboxField({ name, register, error, children, required }: Props) {
  const fieldId = `field-${name}`;
  const errorId = `${fieldId}-error`;

  return (
    <div>
      <label htmlFor={fieldId} className="flex items-start gap-3 cursor-pointer">
        <input
          id={fieldId}
          type="checkbox"
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          className="mt-1 w-4 h-4 rounded border-[#E8E8E4] text-[#00A19B] focus:ring-2 focus:ring-[#00A19B]/20"
          {...register(name)}
        />
        <span className="text-sm text-[#373A36]">
          {children}
          {required && <span className="text-red-500 font-bold ml-0.5">*</span>}
        </span>
      </label>
      {error && (
        <p id={errorId} className="mt-1 text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}
